import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import utils from '../utils';
import { layers } from './layers';
import { featureInfo } from './featureInfo';
import { pcodeSearch } from './pcodeSearch';
import { llpg } from './llpgSearch';
import Vuetify from 'vuetify';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mapConfig: { config: {} },
    appTextColour: 'white'
  },
  mutations: {
    SET_MAP_CONFIG(state, payload) {
      console.dir(payload);
      if (!payload.projection) {
        payload.projection = 'EPSG:3857';
      }

      document.title = payload.title || 'XMAP Public Map';

      state.mapConfig = payload;
    },
    SET_APP_TEXT_COLOUR(state, colour) {
      state.appTextColour = colour;
    }
  },
  actions: {
    FETCH_CONFIG({ commit, dispatch }) {
      let searchParams = utils.getURLParams(window.location.href);
      if (searchParams?.ordering === 'new') {
        commit('layers/SET_LAYER_ORDERING', true);
      }
      axios.get(`${process.env.VUE_APP_AUTH_URL}/public-map/get-config`, {
        params: {
          //map gives backwards compatibility
          id: utils.getURLParams(window.location.href).id || utils.getURLParams(window.location.href).map,
          sid: Math.random(),
        },
        withCredentials: true,
      })
        .then((res) => {
          console.dir(res);
          commit('layers/SET', {
            layers: res.data.layers,
            collections: res.data.collections
          });
          commit('SET_MAP_CONFIG', res.data);
        })
        .catch((err) => {
          if (!err.response.data.data.config) {
            err.response.data.data.config = {};
          }
          commit('SET_MAP_CONFIG', {
            invalid: true,
            reason: err.response.data.message,
            systype: err.response.data.data.config.system_type || null
          });
        });
    }
  },
  getters: {
    CONFIG(state) {
      return state.mapConfig;
    },
    TOOLS(state) {
      return state.mapConfig.config.tools || [];
    },
    GET_ORGID(state) {
      return state.mapConfig.orgid || null;
    },
    GET_ORG_MASK(state) {
      return state.mapConfig.mask || null;
    },
    GET_EXTENT(state) {
      if (state.mapConfig.extent) {
        if (typeof  state.mapConfig.extent === 'string'){
          return state.mapConfig.extent.split(',').map(n => Number(n));
        } else {
          return state.mapConfig.extent
        }
      } else {
        return null;
      }
    },
    CHECK_SYSTEM_TYPE: (state) => (type) => {
      return state.mapConfig.system_type && state.mapConfig.system_type.indexOf(type) > -1;
    },
    /**
     * This is here to mimic the GET_LAYERS getter used in getFeatureInfo
     * It just returns the layers/LAYERS getter
     */
    GET_LAYERS(state, getters) {
      return getters['layers/LAYERS'];
    }
  },
  modules: {
    layers,
    featureInfo,
    pcodeSearch,
    llpg
  },
});
